import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BRANDS } from '../../../components/Itv/types';

/**
 * Component that handles redirecting from root path (/) to the appropriate brand page
 * Returns null as it only performs a side effect
 * This allows for centralized redirect logic that can be easily customized
 */
export const RootRedirect: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/') {
      // TODO: Replace this with your actual variable logic once we have final requirements for time based redirect

      const shouldRedirectToSpins = false; // Replace with your variable logic

      const redirectPath = shouldRedirectToSpins ? `/${BRANDS.SPINS}` : `/${BRANDS.BINGO}`;

      navigate(redirectPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};
